module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('div', {
    staticClass: "col s12"
  }, [_c('markdown-card', {
    attrs: {
      "url": "content/Security.txt"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fac7e8e!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/Security.vue
// module id = 71
// module chunks = 0